import * as i0 from '@angular/core';
import { Injectable, Component, Inject, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil, take } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2$1 from 'file-upload-library';
import * as i4 from 'ngx-toastr';
import * as i5 from 'bulk-upload-dashboard';
import * as i6 from 'custom-button-action';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from 'primeng/dialog';
import * as i9 from 'primeng/dropdown';
import * as i10 from 'primeng/table';
import * as i11 from 'primeng/api';
import * as i12 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';
import { FormsModule } from '@angular/forms';

class LibApplicantDetailsService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getApplicantDetails(applicantId, applicantClientJobPositionsId) {
        const params = {};
        if (applicantClientJobPositionsId !== null && applicantClientJobPositionsId !== undefined) {
            params.applicantClientJobPositionsId = this.toEncrypt(applicantClientJobPositionsId.toString());
        }
        return this.http.get(`/vd/formBuilder/get/applicant/${applicantId}/info`, { params });
    }
    getUploadedDocumentDetails(applicantId) {
        return this.http.get(`/fbUploadedDocs/applicant/${applicantId}/category/APPLICANTRESUMEDOC`);
    }
    deleteFile(id) {
        return this.http.delete(`/vd/fb/delete/talentAcq/applicant/docId/${id}`).pipe(map((data) => {
            return data;
        }));
    }
    getApplicantStatusList() {
        return this.http.get(`/vd/dataSource/APPLICANTSTATUS/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    UpdateStatus(payload) {
        return this.http.post(`/vd/fb/update/talentAcq/appStatus`, payload).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
LibApplicantDetailsService.ɵfac = function LibApplicantDetailsService_Factory(t) { return new (t || LibApplicantDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
LibApplicantDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: LibApplicantDetailsService, factory: LibApplicantDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibApplicantDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["mat-button", "", 1, "btnCustom", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2.Store }]; }, null); })();

function LibApplicantDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "button", 27);
    i0.ɵɵlistener("click", function LibApplicantDetailsComponent_div_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.backToParentPage(); });
    i0.ɵɵelement(2, "i", 28);
    i0.ɵɵtext(3, " Back ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtext(3, "Current/Past Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵtext(8, "Notice Period");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 6);
    i0.ɵɵelementStart(12, "div", 7);
    i0.ɵɵtext(13, "Employment Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 8);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 6);
    i0.ɵɵelementStart(17, "div", 7);
    i0.ɵɵtext(18, "Current CTC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 8);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 6);
    i0.ɵɵelementStart(22, "div", 7);
    i0.ɵɵtext(23, "Expected CTC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 8);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.applicantDetails == null ? null : ctx_r1.applicantDetails.employmentList[0] == null ? null : ctx_r1.applicantDetails.employmentList[0].companyName) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.applicantDetails == null ? null : ctx_r1.applicantDetails.employmentList[0] == null ? null : ctx_r1.applicantDetails.employmentList[0].noticePeriod) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.applicantDetails == null ? null : ctx_r1.applicantDetails.employmentList[0] == null ? null : ctx_r1.applicantDetails.employmentList[0].employmentType == null ? null : ctx_r1.applicantDetails.employmentList[0].employmentType.employmentTypeName) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.applicantDetails == null ? null : ctx_r1.applicantDetails.employmentList[0] == null ? null : ctx_r1.applicantDetails.employmentList[0].ctc == null ? null : ctx_r1.applicantDetails.employmentList[0].ctc.name) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.applicantDetails == null ? null : ctx_r1.applicantDetails.employmentList[0] == null ? null : ctx_r1.applicantDetails.employmentList[0].ectc == null ? null : ctx_r1.applicantDetails.employmentList[0].ectc.name) || "--", " ");
} }
function LibApplicantDetailsComponent_div_55_ng_template_4_tr_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_55_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LibApplicantDetailsComponent_div_55_ng_template_4_tr_0_Template, 5, 0, "tr", 34);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", (ctx_r11.applicantDetails == null ? null : ctx_r11.applicantDetails.applicantInfo == null ? null : ctx_r11.applicantDetails.applicantInfo.file) !== null);
} }
function LibApplicantDetailsComponent_div_55_ng_template_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelementStart(2, "span", 39);
    i0.ɵɵlistener("click", function LibApplicantDetailsComponent_div_55_ng_template_5_div_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r19); const loadData_r15 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.openDoc(loadData_r15); });
    i0.ɵɵelementStart(3, "mat-icon", 40);
    i0.ɵɵtext(4, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "i", 41);
    i0.ɵɵlistener("click", function LibApplicantDetailsComponent_div_55_ng_template_5_div_5_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r19); const loadData_r15 = i0.ɵɵnextContext().$implicit; const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.download(loadData_r15); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelementStart(8, "i", 42);
    i0.ɵɵlistener("click", function LibApplicantDetailsComponent_div_55_ng_template_5_div_5_Template_i_click_8_listener() { i0.ɵɵrestoreView(_r19); const loadData_r15 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.deleteDoc(loadData_r15); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_55_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "p", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, LibApplicantDetailsComponent_div_55_ng_template_5_div_5_Template, 9, 0, "div", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loadData_r15 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loadData_r15 == null ? null : loadData_r15.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (loadData_r15 == null ? null : loadData_r15.fileName) !== null);
} }
function LibApplicantDetailsComponent_div_55_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 3);
} }
function LibApplicantDetailsComponent_div_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵtext(2, "Uploaded Files");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-table", 30);
    i0.ɵɵtemplate(4, LibApplicantDetailsComponent_div_55_ng_template_4_Template, 1, 1, "ng-template", 31);
    i0.ɵɵtemplate(5, LibApplicantDetailsComponent_div_55_ng_template_5_Template, 6, 2, "ng-template", 32);
    i0.ɵɵtemplate(6, LibApplicantDetailsComponent_div_55_ng_template_6_Template, 3, 1, "ng-template", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r2.applicantDetails == null ? null : ctx_r2.applicantDetails.applicantInfo == null ? null : ctx_r2.applicantDetails.applicantInfo.file)("resizableColumns", true);
} }
function LibApplicantDetailsComponent_div_62_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r3.applicantDetails == null ? null : ctx_r3.applicantDetails.applicantInfo == null ? null : ctx_r3.applicantDetails.applicantInfo.applicantStatus == null ? null : ctx_r3.applicantDetails.applicantInfo.applicantStatus.name) || "--", " ");
} }
function LibApplicantDetailsComponent_ng_template_63_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.status, " ");
} }
function LibApplicantDetailsComponent_div_67_div_3_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r27 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Education ", i_r27 + 1, "");
} }
function LibApplicantDetailsComponent_div_67_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵtemplate(2, LibApplicantDetailsComponent_div_67_div_3_h6_2_Template, 2, 1, "h6", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6, "Education");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 6);
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵtext(11, "University/Institute");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 8);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 6);
    i0.ɵɵelementStart(15, "div", 7);
    i0.ɵɵtext(16, "Course");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 8);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 6);
    i0.ɵɵelementStart(20, "div", 7);
    i0.ɵɵtext(21, "Course Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 8);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 6);
    i0.ɵɵelementStart(25, "div", 7);
    i0.ɵɵtext(26, "Specialization");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 8);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 5);
    i0.ɵɵelementStart(30, "div", 6);
    i0.ɵɵelementStart(31, "div", 7);
    i0.ɵɵtext(32, "Course Starting Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 8);
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 6);
    i0.ɵɵelementStart(36, "div", 7);
    i0.ɵɵtext(37, "Course Ending Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 8);
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r26 = ctx.$implicit;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r25.applicantDetails == null ? null : ctx_r25.applicantDetails.educationList == null ? null : ctx_r25.applicantDetails.educationList.length) > 1);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.education == null ? null : e_r26.education.educationName) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.universityName) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.course == null ? null : e_r26.course.course) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.courseType == null ? null : e_r26.courseType.courseType) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.specialization == null ? null : e_r26.specialization.specialization) || "--", " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.courseStartYear) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (e_r26 == null ? null : e_r26.courseEndYear) || "--", " ");
} }
function LibApplicantDetailsComponent_div_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "h5", 3);
    i0.ɵɵtext(2, "Education Details");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LibApplicantDetailsComponent_div_67_div_3_Template, 40, 8, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r6.applicantDetails == null ? null : ctx_r6.applicantDetails.educationList);
} }
function LibApplicantDetailsComponent_div_68_div_3_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r32 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Employment ", i_r32 + 1, "");
} }
function LibApplicantDetailsComponent_div_68_div_3_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, "Current Company Name");
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_68_div_3_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, "Previous Company Name");
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_68_div_3_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, "Current Designation");
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_68_div_3_ng_template_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, "Previous Designation");
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_68_div_3_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, "Current CTC");
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_68_div_3_ng_template_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, "Previous CTC");
    i0.ɵɵelementEnd();
} }
function LibApplicantDetailsComponent_div_68_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵtemplate(2, LibApplicantDetailsComponent_div_68_div_3_h6_2_Template, 2, 1, "h6", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵelementStart(4, "div", 47);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6, "Is this your current employment?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 5);
    i0.ɵɵelementStart(10, "div", 6);
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵtext(12, "Employment Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 8);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 6);
    i0.ɵɵelementStart(16, "div", 7);
    i0.ɵɵtext(17, "Total Experience");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 8);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 6);
    i0.ɵɵtemplate(21, LibApplicantDetailsComponent_div_68_div_3_div_21_Template, 2, 0, "div", 48);
    i0.ɵɵtemplate(22, LibApplicantDetailsComponent_div_68_div_3_ng_template_22_Template, 2, 0, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(24, "div", 8);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 6);
    i0.ɵɵtemplate(27, LibApplicantDetailsComponent_div_68_div_3_div_27_Template, 2, 0, "div", 48);
    i0.ɵɵtemplate(28, LibApplicantDetailsComponent_div_68_div_3_ng_template_28_Template, 2, 0, "ng-template", null, 50, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(30, "div", 8);
    i0.ɵɵtext(31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 6);
    i0.ɵɵelementStart(33, "div", 7);
    i0.ɵɵtext(34, "Joining Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 8);
    i0.ɵɵtext(36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 5);
    i0.ɵɵelementStart(38, "div", 6);
    i0.ɵɵtemplate(39, LibApplicantDetailsComponent_div_68_div_3_div_39_Template, 2, 0, "div", 48);
    i0.ɵɵtemplate(40, LibApplicantDetailsComponent_div_68_div_3_ng_template_40_Template, 2, 0, "ng-template", null, 51, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(42, "div", 8);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 6);
    i0.ɵɵelementStart(45, "div", 7);
    i0.ɵɵtext(46, "Notice Period");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "div", 8);
    i0.ɵɵtext(48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 6);
    i0.ɵɵelementStart(50, "div", 7);
    i0.ɵɵtext(51, "Job & Responsibilities");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(52, "div", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(53, "div", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r31 = ctx.$implicit;
    const _r35 = i0.ɵɵreference(23);
    const _r38 = i0.ɵɵreference(29);
    const _r41 = i0.ɵɵreference(41);
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r30.applicantDetails == null ? null : ctx_r30.applicantDetails.employmentList == null ? null : ctx_r30.applicantDetails.employmentList.length) > 1);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", !(e_r31 == null ? null : e_r31.companyName) && ((e_r31 == null ? null : e_r31.isCurrentEmployment) === 1 || (e_r31 == null ? null : e_r31.isCurrentEmployment) === 0) ? "--" : (e_r31 == null ? null : e_r31.isCurrentEmployment) != null ? (e_r31 == null ? null : e_r31.isCurrentEmployment) == 1 ? "Yes" : "No" : "--", " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", (e_r31 == null ? null : e_r31.employmentType == null ? null : e_r31.employmentType.employmentTypeName) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2(" ", (e_r31 == null ? null : e_r31.totalExperienceInYears) || "--", " Years ", (e_r31 == null ? null : e_r31.totalExperienceInMonths) || "--", " Months ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (e_r31 == null ? null : e_r31.isCurrentEmployment) == 1)("ngIfElse", _r35);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (e_r31 == null ? null : e_r31.companyName) || "--", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (e_r31 == null ? null : e_r31.isCurrentEmployment) == 1)("ngIfElse", _r38);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (e_r31 == null ? null : e_r31.designation) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2(" ", (e_r31 == null ? null : e_r31.joiningDateInMonth) || "--", " ", (e_r31 == null ? null : e_r31.joiningDateInYear) || "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (e_r31 == null ? null : e_r31.isCurrentEmployment) == 1)("ngIfElse", _r41);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (e_r31 == null ? null : e_r31.ctc == null ? null : e_r31.ctc.name) || "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (e_r31 == null ? null : e_r31.noticePeriod) || "--", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("innerHTML", ctx_r30.formattedRoles, i0.ɵɵsanitizeHtml);
} }
function LibApplicantDetailsComponent_div_68_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "h5", 3);
    i0.ɵɵtext(2, "Employment Details");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LibApplicantDetailsComponent_div_68_div_3_Template, 54, 18, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r7.applicantDetails == null ? null : ctx_r7.applicantDetails.employmentList);
} }
function LibApplicantDetailsComponent_div_69_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const q_r45 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(q_r45.applicantQuestion || "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(q_r45.response || "--");
} }
function LibApplicantDetailsComponent_div_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "h5", 3);
    i0.ɵɵtext(2, "Application Additional Questions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtemplate(5, LibApplicantDetailsComponent_div_69_div_5_Template, 6, 2, "div", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r8.applicantDetails == null ? null : ctx_r8.applicantDetails.questionAndResponseList);
} }
const _c0 = function () { return { width: "50vw" }; };
const _c1 = function () { return { "width": "100%" }; };
class LibApplicantDetailsComponent {
    constructor(libApplicantDetailsService, uploadService, dialog, toastr, bulkUploadDashboardService, customButtonActionService) {
        this.libApplicantDetailsService = libApplicantDetailsService;
        this.uploadService = uploadService;
        this.dialog = dialog;
        this.toastr = toastr;
        this.bulkUploadDashboardService = bulkUploadDashboardService;
        this.customButtonActionService = customButtonActionService;
        this.applicantDetails = {};
        this.subscription = [];
        this.observableSubscription$ = new Subject();
        this.allowedRoles = ['Recruiter', 'Recruitment Manager'];
        this.enableTalentPoolChanges = false;
        this.status = '';
        this.getStatusList = [];
    }
    ngOnInit() {
        var _a;
        this.getAppplicantDetails();
        this.fbRole = 'fbRole' in sessionStorage ? sessionStorage.getItem('fbRole') : null;
        this.showContainer = this.allowedRoles.map(role => role.toLowerCase()).includes((_a = this.fbRole) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
        const isViewDetailsForm = sessionStorage.getItem('formName') === "View Details";
        this.enableTalentPoolChanges = isViewDetailsForm;
    }
    getLatestRowID() {
        const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
        return fbFormDataDTO[fbFormDataDTO.length - 1].applicantId;
    }
    getStatus() {
        this.subscription[this.subscription.length] = this.libApplicantDetailsService.getApplicantStatusList()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.getStatusList = response.data;
            }
        });
    }
    openUpdateStatus() {
        this.displayBasic = true;
        this.getStatus();
    }
    onStatusChange(data) {
        this.getStatusPayload = this.getStatusList.filter(x => x.name == data.value);
    }
    addOrUpdateStatus() {
        const applicantId = parseInt(sessionStorage.getItem("applicantId"));
        const clientInfoId = parseInt(sessionStorage.getItem("idToGetDetails"));
        const payload = {
            "applicantClientJobPositionId": clientInfoId,
            "applicantId": applicantId,
            "updateStatus": this.getStatusPayload[0]
        };
        this.subscription[this.subscription.length] = this.libApplicantDetailsService.UpdateStatus(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.status = this.getStatusPayload[0].name;
                this.displayBasic = false;
            }
        });
    }
    transformSkills(skills) {
        return skills ? skills.replace(/,/g, ', ') : '--';
    }
    formatRolesAndResponsibility(roles) {
        return roles ? roles.replace(/\n/g, '<br>') : '--';
    }
    getAppplicantDetails() {
        // if ('applicantId' in sessionStorage) {
        //   sessionStorage.setItem('applicantIdDetail', sessionStorage.getItem('applicantId'));
        // } else if ('applicantIdDetail' in sessionStorage) {
        //   sessionStorage.setItem('applicantId', sessionStorage.getItem('applicantIdDetail'));
        // }
        this.applicantId = 'applicantId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantId')) : 'fbFormDataDTO' in sessionStorage ? this.getLatestRowID() : null;
        this.applicantInfoId = 'applicantInfoId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantInfoId')) : null;
        if (this.applicantId) {
            this.subscription[this.subscription.length] = this.libApplicantDetailsService
                .getApplicantDetails(this.applicantId, this.applicantInfoId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                var _a, _b, _c;
                this.applicantDetails = response.data || null;
                if (this.applicantDetails && ((_a = this.applicantDetails) === null || _a === void 0 ? void 0 : _a.applicantInfo)) {
                    sessionStorage.setItem("toClientEmail", (_c = (_b = this.applicantDetails) === null || _b === void 0 ? void 0 : _b.applicantInfo) === null || _c === void 0 ? void 0 : _c.email);
                    this.formattedSkills = this.transformSkills(this.applicantDetails.employmentList[0].skillsUsed);
                    this.formattedRoles = this.formatRolesAndResponsibility(this.applicantDetails.employmentList[0].jobRolesAndRespon);
                }
            }, (error) => {
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Error fetching applicant details:');
            });
        }
    }
    openDoc(data) {
        //const docPath = item.fileLocation?.substring(23);
        var path;
        if (data.fileLocation.includes("var/www/")) {
            path = environment.appUrl + data.fileLocation.replace('var/www/', '');
        }
        if (data.fileLocation.includes("/var/imagility/uploads/")) {
            path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
        }
        window.open(`${path}`, "_blank");
        //window.open(`${environment.docs}${path}`, '_blank');
    }
    download(data) {
        var _a, _b;
        var path;
        if (data.fileLocation.includes("var/www/")) {
            path = environment.appUrl + data.fileLocation.replace('var/www/', '');
        }
        if (data.fileLocation.includes("/var/imagility/uploads/")) {
            path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
        }
        this.uploadService.downloadDocuments(path, this.isFBUser ? (_a = data.fileLocation) === null || _a === void 0 ? void 0 : _a.split('/').slice(-1)[0] : (_b = data.fileLocation) === null || _b === void 0 ? void 0 : _b.substring(23));
    }
    deleteDoc(item) {
        const title = "Confirm";
        const message = "Do you wish to Delete the File?";
        if (item) {
            this.dialogueInitializer(event, title, message)
                .afterClosed()
                .subscribe((result) => {
                if (result) {
                    this.subscription[this.subscription.length] = this.libApplicantDetailsService.deleteFile(item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                        if (response.status === 200) {
                            this.toastr.success(response.message, 'Success');
                            this.getAppplicantDetails();
                        }
                    });
                }
            });
        }
    }
    dialogueInitializer(event, title, message) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: "400px",
            data: {
                update: { title, message },
                buttons: ["Cancel", "Delete"],
            },
        });
        return dialogRef;
    }
    backToParentPage() {
        let selectedMenu = (JSON.parse(sessionStorage.getItem('selectedMenu')));
        let getPageFormId = selectedMenu.pageFormId;
        if (getPageFormId) {
            this.subscription[this.subscription.length] = this.customButtonActionService.getPageFormById(getPageFormId)
                .pipe(take(1)).subscribe((response) => {
                if (response) {
                    const item = {
                        formType: response.buildFormatTypeId,
                        pageFormId: response.id
                    };
                    this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                }
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.complete();
        this.subscription.forEach(sub => sub.unsubscribe());
    }
}
LibApplicantDetailsComponent.ɵfac = function LibApplicantDetailsComponent_Factory(t) { return new (t || LibApplicantDetailsComponent)(i0.ɵɵdirectiveInject(LibApplicantDetailsService), i0.ɵɵdirectiveInject(i2$1.FileUploadLibraryService), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.BulkUploadDashboardService), i0.ɵɵdirectiveInject(i6.CustomButtonActionService)); };
LibApplicantDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibApplicantDetailsComponent, selectors: [["lib-applicant-details"]], decls: 85, vars: 30, consts: [["class", "col-2 pl-0", 4, "ngIf"], [1, "applicant-heading"], [1, "applicant-details"], [1, "applicant-details-heading"], [1, "applicant-details-card"], [1, "row", "applicant-details-card-row"], [1, "col-2", "detail-section"], [1, "headLbl"], [1, "valueLbl"], ["class", "row applicant-details-card-row", 4, "ngIf"], [1, "applicant-details", "status"], [1, "row", "applicant-details-card-row", "p-0"], [1, "col-6", "pl-0", "detail-section"], ["class", "valueLbl status_value pl-1 pr-1", 4, "ngIf", "ngIfElse"], ["updatedStatus", ""], ["href", "javascript:void(0);", 1, "talent_edit", "ml-2", 3, "click"], ["class", "applicant-details", 4, "ngIf"], ["header", "Add/Update Status", 3, "visible", "modal", "baseZIndex", "draggable", "resizable", "visibleChange"], [1, "change_status_container"], [1, "col-6", "pl-0"], [1, "label-cls"], ["optionLabel", "name", "optionValue", "name", "placeholder", "Select", 3, "options", "onChange"], [1, "mt-4", "status"], [1, "row", "mt-4"], ["type", "button", 1, "btn", "btn-success", "button-width-icon-left", "mr-3", 3, "click"], ["type", "button", 1, "btn", "border-secondary", "text-secondary", "button-width-icon-left", "mr-3", 3, "click"], [1, "col-2", "pl-0"], [1, "back-button", "d-inline-flex", "pl-2", "pr-2", "align-items-center", "mb-3", "talent_edit", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-chevron-circle-left", "pr-1"], [1, "labelHeading", "headlbl", "file-head"], ["styleClass", "table-striped-simple", 3, "value", "resizableColumns"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [4, "ngIf"], [1, "label-name"], ["class", "row file-icons", 4, "ngIf"], [1, "row", "file-icons"], [1, "mr-2", "padding0"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons", "icon-color", "view-icon"], ["title", "Download", 1, "fa", "fa-download", "pr-2", "icn", "icon-color", 3, "click"], ["title", "Delete", 1, "fa", "fa-trash", "icn", "icon-color", 3, "click"], [1, "valueLbl", "status_value", "pl-1", "pr-1"], ["class", "applicant-details-card", 4, "ngFor", "ngForOf"], [1, "row"], ["class", "applicant-details-heading", 4, "ngIf"], [1, "col-6", "detail-section"], ["class", "headLbl", 4, "ngIf", "ngIfElse"], ["company", ""], ["designation", ""], ["ctc", ""], [1, "valueLbl", 3, "innerHTML"], [1, "col-2"], ["class", "col-12 detail-section", 4, "ngFor", "ngForOf"], [1, "col-12", "detail-section"]], template: function LibApplicantDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LibApplicantDetailsComponent_div_0_Template, 4, 0, "div", 0);
        i0.ɵɵelementStart(1, "h4", 1);
        i0.ɵɵtext(2, "Applicant Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "h5", 3);
        i0.ɵɵtext(5, "Basic Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵtext(10, "Job Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 6);
        i0.ɵɵelementStart(14, "div", 7);
        i0.ɵɵtext(15, "First Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 8);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 6);
        i0.ɵɵelementStart(19, "div", 7);
        i0.ɵɵtext(20, "Last Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 8);
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 6);
        i0.ɵɵelementStart(24, "div", 7);
        i0.ɵɵtext(25, "Email ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 8);
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 6);
        i0.ɵɵelementStart(29, "div", 7);
        i0.ɵɵtext(30, "Contact Number");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 8);
        i0.ɵɵtext(32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(33, LibApplicantDetailsComponent_div_33_Template, 26, 5, "div", 9);
        i0.ɵɵelementStart(34, "div", 5);
        i0.ɵɵelementStart(35, "div", 6);
        i0.ɵɵelementStart(36, "div", 7);
        i0.ɵɵtext(37, "Total Experience");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 8);
        i0.ɵɵtext(39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 6);
        i0.ɵɵelementStart(41, "div", 7);
        i0.ɵɵtext(42, "Skills Used");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 8);
        i0.ɵɵtext(44);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 6);
        i0.ɵɵelementStart(46, "div", 7);
        i0.ɵɵtext(47, "Country");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "div", 8);
        i0.ɵɵtext(49);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 6);
        i0.ɵɵelementStart(51, "div", 7);
        i0.ɵɵtext(52, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "div", 8);
        i0.ɵɵtext(54);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(55, LibApplicantDetailsComponent_div_55_Template, 7, 2, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 10);
        i0.ɵɵelementStart(57, "h5", 3);
        i0.ɵɵtext(58, "Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(59, "div", 4);
        i0.ɵɵelementStart(60, "div", 11);
        i0.ɵɵelementStart(61, "div", 12);
        i0.ɵɵtemplate(62, LibApplicantDetailsComponent_div_62_Template, 2, 1, "div", 13);
        i0.ɵɵtemplate(63, LibApplicantDetailsComponent_ng_template_63_Template, 2, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(65, "a", 15);
        i0.ɵɵlistener("click", function LibApplicantDetailsComponent_Template_a_click_65_listener() { return ctx.openUpdateStatus(); });
        i0.ɵɵtext(66, " Update Status ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(67, LibApplicantDetailsComponent_div_67_Template, 4, 1, "div", 16);
        i0.ɵɵtemplate(68, LibApplicantDetailsComponent_div_68_Template, 4, 1, "div", 16);
        i0.ɵɵtemplate(69, LibApplicantDetailsComponent_div_69_Template, 6, 1, "div", 16);
        i0.ɵɵelementStart(70, "p-dialog", 17);
        i0.ɵɵlistener("visibleChange", function LibApplicantDetailsComponent_Template_p_dialog_visibleChange_70_listener($event) { return ctx.displayBasic = $event; });
        i0.ɵɵelementStart(71, "div", 18);
        i0.ɵɵelementStart(72, "div", 19);
        i0.ɵɵelementStart(73, "p", 20);
        i0.ɵɵtext(74, "Status List");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(75, "p-dropdown", 21);
        i0.ɵɵlistener("onChange", function LibApplicantDetailsComponent_Template_p_dropdown_onChange_75_listener($event) { return ctx.onStatusChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(76, "p", 22);
        i0.ɵɵtext(77);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(78, "div", 23);
        i0.ɵɵelementStart(79, "div");
        i0.ɵɵelementStart(80, "button", 24);
        i0.ɵɵlistener("click", function LibApplicantDetailsComponent_Template_button_click_80_listener() { return ctx.addOrUpdateStatus(); });
        i0.ɵɵtext(81, " ADD/UPDATE ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(82, "div");
        i0.ɵɵelementStart(83, "button", 25);
        i0.ɵɵlistener("click", function LibApplicantDetailsComponent_Template_button_click_83_listener() { return ctx.displayBasic = false; });
        i0.ɵɵtext(84, " CANCEL ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(64);
        i0.ɵɵproperty("ngIf", ctx.enableTalentPoolChanges);
        i0.ɵɵadvance(12);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.jobCode) || "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.firstName) || "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.lastName) || "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.email) || "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.phoneNo) || "--", " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.applicantDetails == null ? null : ctx.applicantDetails.employmentList == null ? null : ctx.applicantDetails.employmentList.length) > 0);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.experience) || "--", " Years ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.skillsUsed) ? ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.skillsUsed : (ctx.applicantDetails == null ? null : ctx.applicantDetails.employmentList[0] == null ? null : ctx.applicantDetails.employmentList[0].skillsUsed) ? ctx.applicantDetails == null ? null : ctx.applicantDetails.employmentList[0] == null ? null : ctx.applicantDetails.employmentList[0].skillsUsed : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.country) || "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.stateProvinceName) || "--", " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showContainer || (ctx.applicantDetails == null ? null : ctx.applicantDetails.applicantInfo == null ? null : ctx.applicantDetails.applicantInfo.file));
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.status === "")("ngIfElse", _r4);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", (ctx.applicantDetails == null ? null : ctx.applicantDetails.educationList == null ? null : ctx.applicantDetails.educationList.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.applicantDetails == null ? null : ctx.applicantDetails.employmentList == null ? null : ctx.applicantDetails.employmentList.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.applicantDetails == null ? null : ctx.applicantDetails.questionAndResponseList == null ? null : ctx.applicantDetails.questionAndResponseList.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(28, _c0));
        i0.ɵɵproperty("visible", ctx.displayBasic)("modal", true)("baseZIndex", 10000)("draggable", false)("resizable", false);
        i0.ɵɵadvance(5);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(29, _c1));
        i0.ɵɵproperty("options", ctx.getStatusList);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.getStatusPayload ? ctx.getStatusPayload[0] == null ? null : ctx.getStatusPayload[0].name : "");
    } }, directives: [i7.NgIf, i8.Dialog, i9.Dropdown, i10.Table, i11.PrimeTemplate, i12.MatIcon, i7.NgForOf], styles: [".applicant-details[_ngcontent-%COMP%]   .applicant-details-heading[_ngcontent-%COMP%], .applicant-details[_ngcontent-%COMP%]   .applicant-heading[_ngcontent-%COMP%]{font-size:20px;margin-bottom:20px;margin-top:20px;font-weight:900;color:#4a4a4a}.applicant-details[_ngcontent-%COMP%]   .applicant-heading[_ngcontent-%COMP%]{font-size:24px}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]{background-color:#f7faff;padding:20px}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:40px;padding:16px 0}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .label-sub[_ngcontent-%COMP%]{position:relative;bottom:13px}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .icon-color[_ngcontent-%COMP%]{color:#2196f3!important}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .view-icon[_ngcontent-%COMP%]{margin-top:-2px!important}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .label-name[_ngcontent-%COMP%]{font-weight:600}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .file-head[_ngcontent-%COMP%]{position:relative;left:2px}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .detail-section[_ngcontent-%COMP%]   .headLbl[_ngcontent-%COMP%]{font-size:16px;font-weight:600;color:#4a4a4a}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .detail-section[_ngcontent-%COMP%]   .valueLbl[_ngcontent-%COMP%]{font-size:15px;word-wrap:break-word}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .detail-section[_ngcontent-%COMP%]   .label-light[_ngcontent-%COMP%]{font-style:normal;font-variant:normal;font-weight:400;font-size:14px;line-height:20px!important;font-family:Source Sans Pro}.applicant-details[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]   .applicant-details-card-row[_ngcontent-%COMP%]   .detail-section[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;padding:1px 5px;font-size:12px}.applicant-details[_ngcontent-%COMP%]   .talent_edit[_ngcontent-%COMP%]{text-decoration:none}.applicant-details.status[_ngcontent-%COMP%]   .applicant-details-card[_ngcontent-%COMP%]{background:transparent;padding:0}.change_status_container[_ngcontent-%COMP%]   p.status[_ngcontent-%COMP%], .valueLbl.status_value[_ngcontent-%COMP%]{color:#368a78;font-weight:600;background:#e5f8f4;text-align:center;display:inline-block}.change_status_container[_ngcontent-%COMP%]   p.status[_ngcontent-%COMP%]{width:80%;margin:0 auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibApplicantDetailsComponent, [{
        type: Component,
        args: [{
                selector: "lib-applicant-details",
                templateUrl: "lib-applicant-details.component.html",
                styleUrls: ["lib-applicant-details.component.scss"],
            }]
    }], function () { return [{ type: LibApplicantDetailsService }, { type: i2$1.FileUploadLibraryService }, { type: i1$1.MatDialog }, { type: i4.ToastrService }, { type: i5.BulkUploadDashboardService }, { type: i6.CustomButtonActionService }]; }, null); })();

class LibApplicantDetailsModule {
}
LibApplicantDetailsModule.ɵfac = function LibApplicantDetailsModule_Factory(t) { return new (t || LibApplicantDetailsModule)(); };
LibApplicantDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibApplicantDetailsModule });
LibApplicantDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PrimengLibraryModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibApplicantDetailsModule, { declarations: [LibApplicantDetailsComponent], imports: [CommonModule,
        PrimengLibraryModule,
        FormsModule], exports: [LibApplicantDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibApplicantDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [LibApplicantDetailsComponent],
                imports: [
                    CommonModule,
                    PrimengLibraryModule,
                    FormsModule
                ],
                exports: [LibApplicantDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-applicant-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibApplicantDetailsComponent, LibApplicantDetailsModule, LibApplicantDetailsService };
//# sourceMappingURL=lib-applicant-details.js.map
